import {
  List,
  Datagrid,
  NumberField,
  DateField,
  FunctionField,
  ReferenceInput,
  Filter,
  AutocompleteInput,
  ReferenceField,
} from "react-admin";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";

const createdFromChoises = [
  { id: "MANUALLY_ADMIN", name: "Administrateur" },
  { id: "MANUALLY_OUTLET", name: "Exutoire" },
  { id: "OUTLET", name: "RDV Prestataire" },
];

const createdFromLabels: Record<string, string> = createdFromChoises.reduce(
  (acc, { id, name }) => ({ ...acc, [id]: name }),
  {}
);

const OutletInventoryFilter: React.FC = (props) => (
  <Filter {...props}>
    <ReferenceInput
      source="outlet"
      reference="outlets"
      label="Exutoire"
      perPage={50}
    >
      <AutocompleteInput
        optionText={(record) => `${record.internalCode} - ${record.name}`}
        fullWidth
        label="Exutoire"
        filterToQuery={(searchText: any) => ({
          filterTree: {
            operator: "or",
            operands: [
              {
                term: {
                  name: "name",
                  filterType: "like",
                  value: searchText,
                },
              },
              {
                term: {
                  name: "internalCode",
                  filterType: "like",
                  value: searchText,
                },
              },
            ],
          },
        })}
      />
    </ReferenceInput>
  </Filter>
);

export const OutletInventoryList: React.FC = (props) => {
  return (
    <List
      {...props}
      resource="outlet-inventory"
      sort={{ field: "createdAt", order: "DESC" }}
      filters={<OutletInventoryFilter />}
      title="Inventaire des exutoires"
    >
      <Datagrid>
        <ReferenceField
          label="Exutoire"
          source="outlet"
          reference="outlets"
          link={false}
        >
          <FunctionField render={(record) => record.name} />
        </ReferenceField>
        <NumberField source="airbagsCount" label="Nb airbag" />
        <NumberField source="fullBinsCount" label="Caisses pleines" />
        <NumberField source="emptyBinsCount" label="Caisses vides" />
        <DateField
          source="createdAt"
          label="Date création"
          locales="fr-FR"
          options={{
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }}
        />
        <FunctionField
          source="createdFrom"
          label="Ajouté par"
          render={(record) =>
            createdFromLabels[record.createdFrom] || record.createdFrom
          }
        />
        <FunctionField
          label="Inventaire"
          render={(record) => (
            <Button
              component={Link}
              to={`/outlet-inventory/details/${record.outlet}`}
              variant="outlined"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              Voir
            </Button>
          )}
        />
      </Datagrid>
    </List>
  );
};
